<div class="breadcrumbs">
  <a (click)="goToHarvest()">Harvest - {{ state }}, {{ crop }}</a>&nbsp;/&nbsp;
  <span *ngIf="county === ''">Manage Boundaries</span>
  <span *ngIf="county !== ''">
    <a (click)="goToBoundary()">Boundary - {{county}}</a>&nbsp;/&nbsp;
    Manage Yield History
  </span>
</div>
